import { ANGULAR_EVENT_KEYS } from '../../../constants/system/ANGULAR_EVENT_KEYS';
import { clearUserInfo } from '../clearUserInfo/clearUserInfo';
import { initUserInfo } from '../initUserInfo/initUserInfo';
import { LOCAL_STORAGE_KEYS } from '../../../constants/system/LOCAL_STORAGE_KEYS';
import { broadcastEvent } from '../../angularUtils';
import { CorporateAccountInfo, LoggedInUser } from '../../../interfaces/LoggedInUser';
import { reloadOtherTabs } from '../../windowUtils';

export const setUserInfo = async (
  userData: LoggedInUser | { corporateAccountInfo: CorporateAccountInfo },
) => {
  // Clear without signalling other tabs — we signal once init completes below,
  // so background tabs reload only when fresh user data is fully ready.
  clearUserInfo({ skipTabReload: true });

  localStorage.setItem(LOCAL_STORAGE_KEYS.LOGGED_IN_USER, JSON.stringify(userData));

  await initUserInfo();

  reloadOtherTabs();
  broadcastEvent(ANGULAR_EVENT_KEYS.UPDATE_USER);
};
